import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'

const Carousel = () => {
    return (
        $(`[data-slick]`).not(`.slick-initialized`).slick({
            prevArrow: `<button type="button" class="slick-prev link"></button>`,
            nextArrow: `<button type="button" class="slick-next link"></button>`
        })
    )
}
export { Carousel }